$(document).ready(function() {
  $('.thumbnail-list').css('height',$('.slider-gallery-view').height()); 
  $(window).resize(function(){
   $('.thumbnail-list').css('height',$('.slider-gallery-view').height()); 
  });
  
    $(window).on('load', function() {
      $('.auto-scroll-slider').slick({
        speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
      });
    });
  console.log('test-slider');
  $('.testimonial_slider').slick({
            infinite: true,
    loop:true,
     arrows: true,
      prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',

            dots: false,
    		autoplay: true,
            slidesToShow: 2,
            slidesToScroll: 1,
                       responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });
  
    $('.blog_slider').slick({
            infinite: false,
            arrows: true,
    //   prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Icon_feather-arrow-left_df3c0aed-7808-40b4-a3fb-29c90ae09099.png?v=1650752393"></button>',
    // nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Icon_feather-arrow-right.png?v=1650752393"</button>',
      prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
            dots: false,
    		autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
      rows:0,
                       responsive: [{
                breakpoint: 767,
                settings: "unslick"
            }]
        });
  
  
  
   var winW = $(window).outerWidth();
  if (winW < 767) {
  	$('.icon_text_sec').slick({
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      	arrows: true,
     //  	prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    	// nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>'
         prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
      });
  }


  
  $('fieldset.js.product-form__input.Color input[type=radio]').on('click', function(){
  
  var sclr =  $(this).attr('value');
    $('span.Color.data_clr').text(sclr);
    
  });

  
  
  $('.right-arrow').click(function(){
  		$('.left-arrow').css('opacity', '1');
  });
  
//   $('.modal__close').click(function() {
//    location.reload();
// });
//        $('#product-form-model_product .product-form__submit').click(function() {
//    setTimeout(function(){
//    location.reload();
// }, 2000);
// }); 


  // adv-image-slider
  $('.adv-slick-slide').slick({
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    // prevArrow: '<button class="slick-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    // nextArrow: '<button class="slick-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
    prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 429,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 379,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // adv-testimonials-slide
  $('.adv-testimonials-slide').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    centerMode: true,
    centerPadding:'0px',
    // prevArrow: '<button class="slick-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    // nextArrow: '<button class="slick-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
    prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        }
      },
      {
        breakpoint: 529,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  $('.adv-blogposts-slide').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    centerMode: true,
    centerPadding:'0px',
    // prevArrow: '<button class="slick-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    // nextArrow: '<button class="slick-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
    prevArrow: '<button class="slide-arrow left-arrow "><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="https://cdn.shopify.com/s/files/1/0612/0488/9749/files/Group-2591-rev.png?v=1662791902"</button>',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        }
      },
      {
        breakpoint: 529,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
   
 });






  